import React from 'react';
import { bool, string, node } from 'prop-types';

import Box from '../atoms/Box';
import Text from '../atoms/Text';

const IlluBullet = ({ title, subtitle, description, alignRight, children, ...props }) => {
  return (
    <Box
      position="relative"
      maxWidth="1200px"
      display="flex"
      flexDirection={{ _: 'column', md: alignRight ? 'row-reverse' : 'row' }}
      alignItems="center"
      zIndex="1"
      {...props}>
      {children}
      <Box
        flex={{ _: 3, md: 2 }}
        px={{ _: 0, md: 5, lg: 10 }}
        textAlign={{ _: 'center', md: 'left' }}
        mt={{ _: 2, md: 0 }}>
        <Text tag="h2" styleName="wH2" mb={2}>
          {title}
        </Text>
        <Text tag="h2" styleName="wH4" mb={1}>
          {subtitle}
        </Text>
        <Text styleName="wPBig">{description}</Text>
      </Box>
    </Box>
  );
};

IlluBullet.propTypes = {
  illuName: string,
  title: string,
  subtitle: string,
  description: string,
  className: string,
  alignRight: bool,
  children: node
};

IlluBullet.defaultProps = {
  alignRight: false,
  isSvg: true
};

export default IlluBullet;
